import React, { useState, useMemo, useEffect } from 'react'
import Select from 'react-select'
import countryList from 'react-select-country-list'
import {
  fetchCountries
} from '../../actions'
import {useDispatch, useSelector} from 'react-redux'
import star_icon from '../../assets/images/icons/star-icon.png'




function CountrySelector(props) {
  const options = useMemo(() => countryList().getData(), [])

  const dispatch = useDispatch()


  const apiResponse = useSelector((state)=>{
    const {fetchCountries} = state
    const {countries}  = fetchCountries
    return{
      countries
    }
  })

  var countriesArr = []
  if(apiResponse.countries?.length > 0){
    countriesArr = apiResponse.countries?.map(el=>{
      return{ value: el.id, label: el.name}
    })
  }

  useEffect(()=>{
      dispatch(fetchCountries())
  },[])



  return (
    <div className="dashboard-textfield-container">
        <div className="dashboard-textfield-title">
            <span className="general-span-text">{props.title}</span>
            {props.required && <div>
                        <img src={star_icon}/>
                </div>}
        </div>
        <div className="vertical-select-field-ctn">
          <Select 
            options={countriesArr} 
            value={props.nationality} 
            onChange={props.handleNationality}
            className="vertical-select-field"
            />
        </div>
    </div>
  )
}

export default CountrySelector